// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '7ea65fb9-bfe6-4a15-bf16-529f2286fa5d',
      type: 'Sprite',
      name: 'chest',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chest_Gold',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        '3rd': {
          texture: 'Race_Event_Chest_Bronze'
        },
        '2nd': {
          texture: 'Race_Event_Chest_Silver'
        }
      }
    },
    {
      id: 'b679d4a5-08c4-4cce-be8a-e2dcbad901e4',
      type: 'Container',
      name: 'giftSpawnPoint',
      className: '',
      x: 0,
      y: -110,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '025b33dc-3fc1-4966-b354-00c0d76563ba',
      type: 'Container',
      name: 'particleSpawnPoint',
      className: '',
      x: 0,
      y: -99,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    '2nd',
    '3rd'
  ],
  animations: [
    {
      id: '918c76fa-1fd9-4e8f-8dae-f67ebfafc7a7',
      name: 'Chest_Open',
      playingSpeed: 1,
      totalDuration: 800,
      blocks: [
        {
          id: '944d0256-fa15-4544-b6b9-35a69ac64e94',
          type: 'Tween',
          name: 'squeeze1',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a612224f-cf94-4d97-af34-ece5becdb3fb',
          type: 'Tween',
          name: 'squeeze2',
          duration: 200,
          track: 0,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8c1e185c-0d03-4573-bbe8-295cf3c227ba',
          type: 'Tween',
          name: 'rotation1',
          duration: 300,
          track: 2,
          target: {
            angle: 10
          },
          startAt: 150,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f9bb8cc1-cf30-4c37-9a16-d21b6c508c46',
          type: 'Tween',
          name: 'translation1',
          duration: 300,
          track: 1,
          target: {
            y: -120
          },
          startAt: 150,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '80d0e49c-1884-456f-a66d-ace5068309ff',
          type: 'Tween',
          name: 'squeeze3',
          duration: 150,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 300,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'af743554-6306-4c26-b57b-a3d983f4f2fa',
          type: 'Setter',
          name: 'ANIMEVENT_spawnGifts',
          track: 4,
          target: {},
          startAt: 450,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '4970f281-0011-4772-a043-74a94cb50ec4',
          type: 'Setter',
          name: 'ANIMEVENT_changeTexture',
          track: 3,
          target: {},
          startAt: 450,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '58cadfc2-20bd-4ec3-b547-f24b5d12d538',
          type: 'Tween',
          name: 'squeeze4',
          duration: 150,
          track: 0,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 450,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b0f24312-ec12-4eef-b605-a4609ee6ef59',
          type: 'Tween',
          name: 'rotation2',
          duration: 150,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 470,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6cb9f9ac-b0ed-47b4-a7b0-a98f07315016',
          type: 'Tween',
          name: 'translation2',
          duration: 170,
          track: 1,
          target: {
            y: 0
          },
          startAt: 500,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7bf7ef73-17ad-4b76-b22a-45b21d67fbdd',
          type: 'Setter',
          name: 'FXPART_Race_Event_Particle_Behind_Chest_After_Opening',
          track: 5,
          target: {},
          startAt: 556,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: 'c8fedef1-d77f-4e90-83b9-f79f4c278765',
          type: 'Tween',
          name: 'squeeze5',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 600,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '47e3c703-afe8-4c2d-bcf4-53cc3bc58998',
          type: 'Tween',
          name: 'squeeze6',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 700,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceChestLayout {
  static raw = raw;
  root!: Container;
  chest!: Sprite;
  giftSpawnPoint!: Container;
  particleSpawnPoint!: Container;
  StateName!: '2nd' | '3rd';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Chest_Open {
  Layout: {
    root: object;
    particleSpawnPoint: object;
  };

  BlockTypeByName: {
    squeeze1: object;
    squeeze2: object;
    rotation1: object;
    translation1: object;
    squeeze3: object;
    ANIMEVENT_spawnGifts: object;
    ANIMEVENT_changeTexture: object;
    squeeze4: object;
    rotation2: object;
    translation2: object;
    FXPART_Race_Event_Particle_Behind_Chest_After_Opening: object;
    squeeze5: object;
    squeeze6: object;
  };

  flowData = raw.animations[0];
}
